import React, { useState } from 'react';
import { CheckboxProps, Checkbox, IconButton, Tooltip } from '@mui/material';
import {
  GridColDef,
  GridHeaderCheckbox,
  GRID_CHECKBOX_SELECTION_COL_DEF,
} from '@mui/x-data-grid-pro';
import { ConfirmDialog } from '../ConfirmDialog/ConfirmDialog';
import { useTranslation } from 'react-i18next';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

type MultipleActionBtnComponentProps = {
  disabled: boolean;
  handleActionBtn: () => void;
  testId?: string;
  clearSelection: () => void;
  title: string;
  icon?: JSX.Element;
} & (ConfirmProps | WithoutConfirmProps);

type ConfirmProps = {
  useConfirm: true;
  confirmMsg: string;
  onClose?(): void;
  onAbort?(): void;
};
type WithoutConfirmProps = { useConfirm?: false };

export function MultipleActionBtnComponent({
  useConfirm = false,
  ...props
}: MultipleActionBtnComponentProps) {
  const confirmProps = props as unknown as ConfirmProps;
  const { t } = useTranslation();
  const [dialogProps, setDialogProps] = useState<{
    open: boolean;
    msg: string;
  }>({
    open: false,
    msg: '',
  });

  function onMultipleActionClick() {
    if (useConfirm) {
      setDialogProps({ msg: confirmProps.confirmMsg, open: true });
      return;
    }
    onConfirm();
  }

  function onClose() {
    setDialogProps({ open: false, msg: '' });
    confirmProps.onClose?.();
  }

  function onAbort() {
    setDialogProps({ open: false, msg: '' });
    confirmProps.onAbort?.();
  }

  function onConfirm() {
    props.handleActionBtn();
    onClose();
  }

  return (
    <>
      <Tooltip title={props.title}>
        <span style={{ alignSelf: 'center' }}>
          <IconButton
            onClick={onMultipleActionClick}
            component="span"
            disabled={props.disabled}
            test-id={props.testId + '-btn'}
          >
            {props.icon || <></>}
          </IconButton>
        </span>
      </Tooltip>

      <ConfirmDialog
        title={'Bekreftelse'}
        open={dialogProps.open}
        onAbort={onAbort}
        onClose={onClose}
        onConfirm={onConfirm}
      >
        {t(`${dialogProps.msg}\nFortsett?`)}
      </ConfirmDialog>
    </>
  );
}

export function getGridCheckboxColDef(checked: boolean = false, disableMultipleSelection?: boolean) {
  const title = checked ? 'Velg ingen' : 'Velg alle';
  const checkboxColDef: GridColDef = {
    ...GRID_CHECKBOX_SELECTION_COL_DEF,
    renderHeader: (params) => (
      disableMultipleSelection ? <></> :
      <Tooltip title={title}>
        <div>
          <GridHeaderCheckbox {...params} />
        </div>
      </Tooltip>
    ),
  };
  return checkboxColDef;
}

export const RadioGridCheckbox = React.forwardRef<HTMLButtonElement, CheckboxProps>(
  (props, ref) => {
    
    return (
      <Checkbox
        ref={ref}
        {...props}
        disableRipple
        checkedIcon={<RadioButtonCheckedIcon />}
        icon={<RadioButtonUncheckedIcon />}       
      />
    );
  }
);
